import React, { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { useTranslation } from "react-i18next";

import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import { Clients } from "../../../types/enums";

const styles: any = {
  [Clients.MMTC]: {
    default: {
      border: "1px solid #DBE2FF !important;",
      backgroundColor: "#f8f9fd !important;",
      color: "black !important;",
      fontSize: "14px !important;",
      width: "100% !important;",
    },
    active: {
      backgroundColor: "#40b4b4 !important;",
      border: "1px solid #40b4b4 !important;",
      color: "white !important;",
      fontSize: "14px !important;",
      width: "100% !important;",
    },
  },
};
export default function ButtonGroupComponent({
  buttons,
  selectedButton,
  handleChange,
  className,
  buttonSize,
  field,
  errorMsg,
  isApplicationSubmitted,
  isExpandedView,
  sectionName,
  currentObjFieldError,
  client,
  propertyId,
  unitId,
  loanDetails,
  dynamicConfig,
}: {
  buttons: any;
  selectedButton: string;
  handleChange: any;
  className: string;
  buttonSize: string;
  field: any;
  errorMsg: string;
  isApplicationSubmitted: boolean;
  isExpandedView: boolean;
  sectionName: string;
  currentObjFieldError: any;
  client: string;
  propertyId: any;
  unitId: any;
  loanDetails: any;
  dynamicConfig: any;
}) {
  const { t } = useTranslation();

  // Local buffer, same reasoning as TextFieldComponent — selectedButton
  // round-trips through LoansContext before the pressed state would
  // otherwise update, which reads as a delay highlighting the clicked button.
  const [localSelectedButton, setLocalSelectedButton] = useState(selectedButton);
  useEffect(() => {
    setLocalSelectedButton(selectedButton);
  }, [selectedButton]);

  let selectedBtn = localSelectedButton;

  if (field?.label === "decliningMarkets" && localSelectedButton === undefined) {
    selectedBtn = "No";
  }

  return (
    <FormControl variant="outlined" sx={{ width: "100%" }}>
      <ButtonGroup size="large">
        {buttons?.map((btn: any) => {
          return (
            <Button
              key={btn.label}
              size="medium"
              style={{ width: "100%" }}
              sx={
                btn.value === selectedBtn
                  ? styles?.[client]?.active
                  : styles?.[client]?.default
              }
              color={currentObjFieldError && !!errorMsg ? "error" : "primary"}
              variant={btn.label === selectedBtn ? "contained" : "outlined"}
              disabled={
                dynamicConfig?.allowEditAfterSubmit &&
                !(
                  field?.isAutoCalculated &&
                  field?.isAutoCalculated({
                    sizingType: loanDetails?.sizingType,
                  })
                )
                  ? false
                  : isApplicationSubmitted ||
                    field?.isAutoCalculated({
                      sizingType: loanDetails?.sizingType,
                    })
              }
              onClick={() => {
                // flushSync — see TextFieldComponent for why this is needed
                // to avoid React 18 batching this with LoansContext's
                // heavier update. (startTransition was also tried, to
                // yield/paint in between, but caused hangs under rapid
                // input — reverted.)
                flushSync(() => setLocalSelectedButton(btn.value));
                handleChange(
                  btn.value,
                  "buttonGroup",
                  field,
                  sectionName,
                  propertyId,
                  unitId
                );
              }}
              data-testid={btn.label}
            >
              {t(btn.label)}
            </Button>
          );
        })}
      </ButtonGroup>
      {currentObjFieldError ? (
        <FormHelperText className="break-word">{t(errorMsg)}</FormHelperText>
      ) : null}
    </FormControl>
  );
}
